module.exports = __webpack_public_path__ + "assets/img/e00aabb84c5ecea5dad9e2196821c546.png";